import React from "react";
import DatePicker from 'material-ui-pickers/DatePicker';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
import ruLocale from 'date-fns/locale/ru';
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

class MaterialDatePicker extends React.Component {

    render() {
        const { value, onChange, label, fullsize = false } = this.props;
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
               <DatePicker value={value}
                           autoOk={true}
                           okLabel="Выбрать"
                           padding="dense"
                           style={{ width: fullsize ? 250 : 170 }}
                           margin="dense"
                           cancelLabel="закрыть"
                           invalidDateMessage="Неверный формат даты"
                           maxDateMessage="Дата не должна превышать сегодняшнюю"
                           disableFuture={true}
                           leftArrowIcon={<KeyboardArrowLeftIcon />}
                           rightArrowIcon={<KeyboardArrowRightIcon />}
                           variant="outlined"
                           label={label}
                           format="dd.MM.yyyy"
                           mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
                           onChange={onChange} />
            </MuiPickersUtilsProvider>
        )
    }
}

export default MaterialDatePicker;



// WEBPACK FOOTER //
// ./src/components/MaterialDatePicker.js